import { isBrowser } from "utils/infrastructure/ssg-utils"

function getBody() {
    return isBrowser() ? document.body : undefined
}

function getDocumentElement() {
    return isBrowser() ? document.documentElement : undefined
}

const documentElement = getDocumentElement()

const body = getBody()
const initialBodyStyle = body?.getAttribute("style")
const initialDocumentStyle = getDocumentElement()?.getAttribute("style")

function cleanStyles(el?: HTMLElement, initialStyle?: string | null) {
    el?.setAttribute("style", initialStyle ?? "")
}

function setStyles(el?: HTMLElement, style?: string | null) {
    el?.setAttribute("style", style ?? "")
}

export const bodyStyles = {
    clean: cleanStyles.bind(null, body, initialBodyStyle),
    set: setStyles.bind(null, body),
}

export const documentStyles = {
    clean: cleanStyles.bind(null, documentElement, initialDocumentStyle),
    set: setStyles.bind(null, documentElement),
}
